<div class="note-list-container">
  <table mat-table [dataSource]="noteDataSource" matSort>

    <ng-container matColumnDef="typeOfMeeting">
      <th mat-header-cell *matHeaderCellDef> Rodzaj </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="!disableLinks">
          <a class="default-link" [routerLink]="['/notatki/szczegoly', element.uuid]">
            {{ element?.typeOfMeeting?.name}}
          </a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="meetingDateTime">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="meetingDateTime"> Data </th>
      <td mat-cell *matCellDef="let element">
        <a class="default-link" [routerLink]="['/notatki/szczegoly', element.uuid]">
          {{ element.meetingDateTime | date: 'yyyy-MM-dd HH:mm':'UTC' }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="meetingEndDate">
      <th mat-header-cell *matHeaderCellDef> Data do </th>
      <td mat-cell *matCellDef="let element">
        <a *ngIf="element?.meetingEndDate">{{element?.meetingEndDate | date: 'yyyy-MM-dd'}}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="partnerOrOfwca">
      <th mat-header-cell *matHeaderCellDef> Partner/OFWCA </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.partner">
          Partner: <a class="default-link" [routerLink]="['/partnerzy/szczegoly', element.partner?.uuid]">{{element.partner?.shortName}}</a>
        </ng-container>

        <ng-container *ngIf="element.ofwca">
          OFWCA: <a class="default-link" [routerLink]="['/ofwca/szczegoly', element.ofwca?.uuid]">{{element.ofwca.fullName}}</a>
        </ng-container>
        <ng-container *ngIf="element.partnerOutsideStructure">
          Partner poza strukturą: {{element.partnerOutsideStructure}}
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="regionalAsset">
      <th mat-header-cell *matHeaderCellDef> Regionalny majątek </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="!disableLinks">
          <a *ngIf="element.regional">{{element.regional.fullName}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="tookPlace">
      <th mat-header-cell *matHeaderCellDef> Spotkanie odwołane </th>
      <td mat-cell *matCellDef="let element">
        {{element.tookPlace ? 'Tak' : 'Nie'}}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdBy">
      <th mat-header-cell *matHeaderCellDef> Użytkownik </th>
      <td mat-cell *matCellDef="let element">
        <ng-container *ngIf="element.createdBy">
          <a class="default-link" [routerLink]="['/uzytkownicy/szczegoly', element.createdBy.uuid]">{{element.createdBy.firstName +' '+ element.createdBy.lastName}}</a>
        </ng-container>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element">
        <button mat-icon-button [matMenuTriggerFor]="menu">
          <mat-icon>expand_more</mat-icon>
        </button>
        <mat-menu #menu="matMenu" xPosition="before">
          <button [disabled]="!((userPermissions | async)?.note?.admin_root || element.createdBy?.uuid === profile?.userId)" mat-menu-item (click)="deleteNote(element)">
            Usuń
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

  </table>

  <mat-paginator [pageSizeOptions]="[10, 20, 50,]"></mat-paginator>
</div>
